module.exports = __webpack_public_path__ + "img/04-title-01.6b6a24c1.png";